export default __webpack_public_path__ + "static/media/T51.3ec0d0b5.JPG";